/** Conta quantas conversas têm pelo menos uma mensagem por ler. */
export function contarConversasComNaoLidas(conversas: { nao_lidas: number }[]): number {
  return conversas.filter((c) => c.nao_lidas > 0).length;
}
